import React from 'react';
import { useTranslation } from 'react-i18next';

const VATToggle = ({
    value,
    onChange,
    label,
    costType,
    disabled = false
}) => {
    const { t } = useTranslation();

    const handleToggle = (includesVAT) => {
        if (!disabled) {
            onChange(includesVAT);
        }
    };

    return (
        <div className="vat-toggle-container mb-3">
            <label className="block text-sm font-medium text-gray-700 mb-2">
                {label}
            </label>
            <div className="flex items-center space-x-4 rtl:space-x-reverse">
                <button
                    type="button"
                    onClick={() => handleToggle(true)}
                    disabled={disabled}
                    className={`px-4 py-2 rounded-md text-sm font-medium transition-colors ${value
                        ? 'bg-green-600 text-white'
                        : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
                        } ${disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}`}
                >
                    {t('accounting.vat_toggle.yes')}
                </button>
                <button
                    type="button"
                    onClick={() => handleToggle(false)}
                    disabled={disabled}
                    className={`px-4 py-2 rounded-md text-sm font-medium transition-colors ${!value
                        ? 'bg-red-600 text-white'
                        : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
                        } ${disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}`}
                >
                    {t('accounting.vat_toggle.no')}
                </button>
            </div>
            <div className="mt-2 text-xs text-gray-500">
                {value
                    ? t('accounting.vat_toggle.vat_included')
                    : t('accounting.vat_toggle.vat_excluded')
                }
            </div>
        </div>
    );
};

export default VATToggle;